export enum BookingType {
  WARRANTY = 'WARRANTY',
  SALE = 'SALE'
}
